/* eslint-disable */

/**
 * DO NOT EDIT THIS FILE
 */
import type { FilterRequest } from '../module/yanolja/filter-request';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';
import { KinesisTracker } from '@weberus/client-tracker';

/**
 * PageName: PLACE_LIST
 */
export const PlaceListPageLog = {
  ListNameButtonQuickFilter: {
    /**
     * PlaceList 숙소 목록 내 퀵필터 노출
     * 이미지 : https://screen.yanolja.in/z8uKXY0i4wQHJhVV.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L6}
     * ProductListQuickFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L30}
     */
    impression({
      selected,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonQuickFilter.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 476,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'quickFilter',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        selected,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * PlaceList 숙소 목록 내 퀵필터 클릭
     * 이미지 : https://screen.yanolja.in/z8uKXY0i4wQHJhVV.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L19}
     * ProductListQuickFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L30}
     */
    click({ selected, sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonQuickFilter.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 477,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'quickFilter',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        selected,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonFilter: {
    /**
     * PlaceList 숙소 목록 내 리스트 필터 클릭
     * 클릭시 '필터 항목 리스트' 화면이 보임
     *이미지 : https://screen.yanolja.in/UxDbap6f0ePpkANL.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L32}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonFilter.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 478,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'filterList',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonSetSort: {
    /**
     * PlaceList 숙소 목록 내 '정렬' 노출
     * 이미지 : https://screen.yanolja.in/TZIoW2uxXmi7hlrp
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L46}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    impression({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonSetSort.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 479,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setSort',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * PlaceList 숙소 목록 내 '정렬' 클릭
     * 이미지 : https://screen.yanolja.in/TZIoW2uxXmi7hlrp
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L59}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonSetSort.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 480,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setSort',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonSetSortComplete: {
    /**
     * PlaceList 퀵필터 중 '정렬' 변경 적용
     * 정렬의 경우 적용 버튼이 따로 존재함 - 이미지 : https://screen.yanolja.in/VMmeUGGYifmm2Ttr
     *######## 아래 events 들은 모두 < PlaceList 필터 리스트 >  ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L72}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonSetSortComplete.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 481,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setSortComplete',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameLabelSection: {
    /**
     * PlaceList 필터 리스트 - 각 영역 노출
     * 이미지 : https://screen.yanolja.in/gn3lS1zE0e2xk9ta
     *라벨의 노출되는 시점에 남길길 희망
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L89}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameLabelSection.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 482,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'sectionLabelName',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameSliderPriceRange: {
    /**
     * PlaceList 필터 리스트 - 가격 범위 슬라이더 조절
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L102}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameSliderPriceRange.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 483,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'priceRangeSlider',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_SLIDER',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameTextFieldPriceRange: {
    /**
     * PlaceList 필터 리스트 - 가격 범위 커서 활성화
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L115}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameTextFieldPriceRange.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 484,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'priceRangeTextField',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TEXT_FIELD',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonMoreBtn: {
    /**
     * PlaceList 필터 리스트 - 더보기 클릭
     * 더보기 버튼이 있는 영역
     *시설/서비스 영역 - 이미지 : https://screen.yanolja.in/QSCM9vSmyMtg74Pp
     *숙소 위치 영역 - 이미지 : https://screen.yanolja.in/RUcotlArP9BMOqQA
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L128}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonMoreBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 485,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'moreBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonResetBtn: {
    /**
     * PlaceList 필터 리스트 - 초기화 버튼 클릭
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L144}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonResetBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 486,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'resetBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonFilterComplete: {
    /**
     * PlaceList 필터 리스트 - 필터 적용 버튼 클릭
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L157}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    click({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonFilterComplete.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 487,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'filterListComplete',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonNoResult: {
    /**
     * PlaceList 필터 리스트 - 적용 버튼 noResult 노출
     * 이미지 : https://screen.yanolja.in/HiL1RDTmYlJQaTSl
     *적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L170}
     * ProductListGlobalFilterClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L40}
     */
    impression({
      containerDetail,
      minmax,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonNoResult.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 488,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'noResult',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_IMPR',
        containerDetail,
        minmax,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonCheckInOutDateAndSetPeople: {
    /**
     * 국내숙소 체크인아웃 날짜 및 인원수 클릭
     * PLP에서는 체크인아웃 날짜 및 인원수 버튼이 하나로 통합되어 있음
     *https://screen.yanolja.in/S5NVuTSGnCvTHYnr.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L185}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonCheckInOutDateAndSetPeople.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 492,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'checkInOutDateAndSetPeople',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonCheckInOutDate: {
    /**
     * 국내숙소 체크인아웃 날짜 클릭
     * SRP에서는 체크인아웃 날짜와 인원수 버튼이 분리되어 있음
     *https://screen.yanolja.in/dgDDUvf86GIc3GmR.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L199}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonCheckInOutDate.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 493,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'checkInOutDate',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonSetPeople: {
    /**
     * 국내숙소 인원변경 클릭
     * SRP에서는 체크인아웃 날짜와 인원수 버튼이 분리되어 있음
     *https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L213}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, listName }: PlaceListPageLog.ListNameButtonSetPeople.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 494,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setPeople',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonCheckInOutDate495: {
    /**
     * 국내숙소 - bottom sheet 내에서 체크인아웃 날짜 클릭
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L227}
     * ProductListCheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L59}
     */
    click({
      containerDetail,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonCheckInOutDate495.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 495,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'checkInOutDate',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonSetPeople496: {
    /**
     * 국내숙소 - bottom sheet 내에서 인원 변경 클릭
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L240}
     * ProductListCheckInOutDateAndSetPeopleClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L59}
     */
    click({
      containerDetail,
      sourcePage,
      locationInfo,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameButtonSetPeople496.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 496,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setPeople',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        containerDetail,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameLabelChangeCheckInOutDate: {
    /**
     * 국내숙소 - 숙소리스트 내 날짜 변경 완료 (설정 후 확인 클릭 시, 변경된 날짜 로깅)
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *########  < PlaceList 필터 리스트 >  정의 끝 ######
     *상품 impr/click 로그와 추천위젯 내 상품 impr/click 로그 순서 관련 필드 설명 정의
     *# 전체 리스트 내 상품 위치
     *## 상품 impr/click 로그: position
     *## 추천 위젯: listPosition
     *# 특정 영역 내 상품 위치(광고 슬록, 비광고 슬롯, 추천위젯 내)
     *## 상품 impr/click 로그: positionInSlot
     *## 추천 위젯: position (다른 지면에 노출되는 위젯들과 동일하게 가져가기 위함)
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L253}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    bg({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListNameLabelChangeCheckInOutDate.Bg) {
      return KinesisTracker.bg('PLACE_LIST', {
        clientEventId: 514,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'changeCheckInOutDate',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_BG',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNamePlaceNoImprProd: {
    /**
     * PlaceList - 상품 리스트 내 숙소 노출
     * objectsWith를 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     **** SRP 버티컬 탭 통합 전까지는 objectsWith에 아래의 message가 들어가야 합니다.
     *# 노출 로그가 하나였을 때는 ['{상품}', '{상품}', '{상품}'] 형식이었으나, 상품별로 로그를 발생시키면서
     *# ['{상품}']의 형태로 들어갑니다. # 이미지: https://screen.yanolja.in/tk2HqoGV2u68aRqF.png
     *https://screen.yanolja.in/Quty64RuqijVNRps.png
     *event_label : "imprPlace"  # 해당 이벤트도 구버전이므로 주석으로 정리 - 실제로는 남기는 값
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L275}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNamePlaceNoImprProd.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 489,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'imprProd',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_PLACE_NO',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNamePlaceNo: {
    /**
     * PlaceList - 상품 리스트 내 숙소 클릭
     * https://screen.yanolja.in/Quty64RuqijVNRps.png
     *event_label : "clickPlace"  # 해당 이벤트는 구버전이므로 주석으로 정리 - 실제로는 남기는 값
     *########  < 국내숙소 recommendSection 위젯 >  정의 시작 #########
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L302}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      placeNo,
      listName,
    }: PlaceListPageLog.ListNamePlaceNo.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 490,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: placeNo,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_PLACE_NO',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  RecommendSectionCardWidgetItem: {
    /**
     * 국내숙소 리스트 - 추천 위젯 내 상품 노출
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L318}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    impression({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: PlaceListPageLog.RecommendSectionCardWidgetItem.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 527,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * 국내숙소 리스트 - 추천 위젯 내 상품 클릭
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L330}
     * ProductListRecommendSectionCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L69}
     */
    click({
      position,
      listPosition,
      noAvailablePlaceMsg,
      sourcePage,
      locationInfo,
      logMeta,
    }: PlaceListPageLog.RecommendSectionCardWidgetItem.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 528,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'widgetItem',
        objectContainer: 'recommendSection',
        objectType: 'OBJECT_TYPE_CARD',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        listPosition,
        noAvailablePlaceMsg,
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameLabelNoAvailablePlaceMsg: {
    /**
     * 검색결과 - NoResult 노출
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L342}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameLabelNoAvailablePlaceMsg.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 491,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'NoAvailablePlaceMsg',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNameLabelSpellCorrectionMsg: {
    /**
     * 검색결과 철자 오류 보정 키워드 리스트 노출
     * https://screen.yanolja.in/gn7ng86cx3VNOF8t
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L355}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameLabelSpellCorrectionMsg.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 497,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'spellCorrectionMsg',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * 검색결과 철자 오류 보정 키워드 리스트 클릭
     * https://screen.yanolja.in/gn7ng86cx3VNOF8t
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L368}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameLabelSpellCorrectionMsg.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 498,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'spellCorrectionMsg',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListNameButtonBackwardBtn: {
    /**
     * 뒤로가기 버튼 클릭
     * https://screen.yanolja.in/9CBq2ar1c7oBaCpS.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L381}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    click({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListNameButtonBackwardBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 499,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'backwardBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNameButtonHomeBtn: {
    /**
     * 홈 버튼 클릭
     * https://screen.yanolja.in/TuQAu1HUSlhlacPS.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L393}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    click({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListNameButtonHomeBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 500,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'homeBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNameButtonCartBtn: {
    /**
     * 장바구니 버튼 클릭
     * https://screen.yanolja.in/iZdwEbPaKpsd2ruP.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L405}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    click({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListNameButtonCartBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 501,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'cartBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNameButtonSearchBtn: {
    /**
     * 검색창 버튼 클릭
     * https://screen.yanolja.in/aBNE3bA0sOBf76gL
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L417}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    click({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListNameButtonSearchBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 502,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'searchBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNameTabBtn: {
    /**
     * 탭 버튼 노출
     * https://screen.yanolja.in/rQmX5bjr5Kr87Jbs.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L429}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameTabBtn.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 503,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'tabBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * 탭 버튼 클릭
     * https://screen.yanolja.in/rQmX5bjr5Kr87Jbs.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L442}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameTabBtn.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 504,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'tabBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  RelatedKeywordsLabelKeyword: {
    /**
     * 함께 찾는 검색어 노출
     * https://screen.yanolja.in/A0uxbUXfpQIlrA1d.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L455}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
    }: PlaceListPageLog.RelatedKeywordsLabelKeyword.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 505,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'RelatedKeyword',
        objectContainer: 'relatedKeywords',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  RelatedKeywordsLabel: {
    /**
     * 함께 찾는 검색어 클릭
     * https://screen.yanolja.in/A0uxbUXfpQIlrA1d.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L468}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      relatedKeywords,
    }: PlaceListPageLog.RelatedKeywordsLabel.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 506,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: relatedKeywords,
        objectContainer: 'relatedKeywords',
        objectType: 'OBJECT_TYPE_LABEL',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },

  ListName: {
    /**
     * 국내숙소 리스트 진입
     * https://screen.yanolja.in/WhsqGVJCEeJpJctm.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L481}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    view({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListName.View) {
      return KinesisTracker.view('PLACE_LIST', {
        clientEventId: 507,
        pageName: 'PAGE_NAME_PLACE_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_VIEW',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },

    /**
     * 국내숙소 리스트 진입
     * https://screen.yanolja.in/WhsqGVJCEeJpJctm.png
     *########  < 국내숙소 지역별 리스트 >  정의 시작 ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L490}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    resume({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceListPageLog.ListName.Resume) {
      return KinesisTracker.resume('PLACE_LIST', {
        clientEventId: 508,
        pageName: 'PAGE_NAME_PLACE_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_RESUME',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNameButtonSetMapview: {
    /**
     * 리스트 지도뷰 클릭
     * https://screen.yanolja.in/usveO76fAla16W4l.png
     *########  < 국내숙소 지도뷰 리스트 >  정의 시작 #########
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L558}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    click({ logMeta, listName }: PlaceListPageLog.ListNameButtonSetMapview.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 516,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'setMapview',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ListNameBannerOm: {
    /**
     * OMBanner 노츌
     * https://screen.yanolja.in/PNjIf2au562k798M
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L619}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameBannerOm.Impression) {
      return KinesisTracker.impression('PLACE_LIST', {
        clientEventId: 557,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'OMBanner',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * OMBanner 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L632}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      listName,
    }: PlaceListPageLog.ListNameBannerOm.Click) {
      return KinesisTracker.click('PLACE_LIST', {
        clientEventId: 558,
        pageName: 'PAGE_NAME_PLACE_LIST',
        object: 'OMBanner',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BANNER',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace PlaceListPageLog {
  export namespace ListNameButtonQuickFilter {
    /**
     * 이미지 : https://screen.yanolja.in/z8uKXY0i4wQHJhVV.png
     */
    export interface Impression {
      /* 실제 노출 되는 값 : {&#34;selected&#34;: True } / {&#34;selected&#34;:False}*/
      selected?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * 이미지 : https://screen.yanolja.in/z8uKXY0i4wQHJhVV.png
     */
    export interface Click {
      /* 실제 노출 되는 값 : {&#34;selected&#34;: True } / {&#34;selected&#34;:False}*/
      selected?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonFilter {
    /**
     * 클릭시 '필터 항목 리스트' 화면이 보임
     *이미지 : https://screen.yanolja.in/UxDbap6f0ePpkANL.png
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetSort {
    /**
     * 이미지 : https://screen.yanolja.in/TZIoW2uxXmi7hlrp
     */
    export interface Impression {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * 이미지 : https://screen.yanolja.in/TZIoW2uxXmi7hlrp
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetSortComplete {
    /**
     * 정렬의 경우 적용 버튼이 따로 존재함 - 이미지 : https://screen.yanolja.in/VMmeUGGYifmm2Ttr
     *######## 아래 events 들은 모두 < PlaceList 필터 리스트 >  ######
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameLabelSection {
    /**
     * 이미지 : https://screen.yanolja.in/gn3lS1zE0e2xk9ta
     *라벨의 노출되는 시점에 남길길 희망
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameSliderPriceRange {
    /**
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameTextFieldPriceRange {
    /**
     * https://screen.yanolja.in/4KoEsMeb1u6IVSVa
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonMoreBtn {
    /**
     * 더보기 버튼이 있는 영역
     *시설/서비스 영역 - 이미지 : https://screen.yanolja.in/QSCM9vSmyMtg74Pp
     *숙소 위치 영역 - 이미지 : https://screen.yanolja.in/RUcotlArP9BMOqQA
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonResetBtn {
    /**
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonFilterComplete {
    /**
     * 이미지 https://screen.yanolja.in/JmPnPQMcLjSGYAss
     */
    export interface Click {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonNoResult {
    /**
     * 이미지 : https://screen.yanolja.in/HiL1RDTmYlJQaTSl
     *적용 버튼이 noResult 활성화 될 때 노출 로그 발생 (어떤 조합으로 noResult 가 발생하는지 확인 가능 용도)
     */
    export interface Impression {
      /* 해당 모달에 대한 값 : {&#39;containerDetail&#39; : &#39;filterList&#39;}*/
      containerDetail: string;
      /* priceRangeSlider &amp; priceRangeTextField 만 남기는 값 {&#39;minmax&#39;:&#39;min&#39;}/{&#39;minmax&#39;:&#39;max&#39;}*/
      minmax?: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonCheckInOutDateAndSetPeople {
    /**
     * PLP에서는 체크인아웃 날짜 및 인원수 버튼이 하나로 통합되어 있음
     *https://screen.yanolja.in/S5NVuTSGnCvTHYnr.png
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonCheckInOutDate {
    /**
     * SRP에서는 체크인아웃 날짜와 인원수 버튼이 분리되어 있음
     *https://screen.yanolja.in/dgDDUvf86GIc3GmR.png
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetPeople {
    /**
     * SRP에서는 체크인아웃 날짜와 인원수 버튼이 분리되어 있음
     *https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonCheckInOutDate495 {
    /**
     * https://screen.yanolja.in/maUkB6hUdVwzGf6w.png
     */
    export interface Click {
      /* 해당 모달에 관한 값: {&#39;containerDetail&#39; : &#39;bottomSheet&#39;}*/
      containerDetail: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonSetPeople496 {
    /**
     * https://screen.yanolja.in/Tj1unrmf5bJs36lU.png
     */
    export interface Click {
      /* 해당 모달에 관한 값: {&#39;containerDetail&#39; : &#39;bottomSheet&#39;}*/
      containerDetail: string;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameLabelChangeCheckInOutDate {
    /**
     * https://screen.yanolja.in/FERmFZRzGq3j7CZh.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가함
     *########  < PlaceList 필터 리스트 >  정의 끝 ######
     *상품 impr/click 로그와 추천위젯 내 상품 impr/click 로그 순서 관련 필드 설명 정의
     *# 전체 리스트 내 상품 위치
     *## 상품 impr/click 로그: position
     *## 추천 위젯: listPosition
     *# 특정 영역 내 상품 위치(광고 슬록, 비광고 슬롯, 추천위젯 내)
     *## 상품 impr/click 로그: positionInSlot
     *## 추천 위젯: position (다른 지면에 노출되는 위젯들과 동일하게 가져가기 위함)
     */
    export interface Bg {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNamePlaceNoImprProd {
    /**
     * objectsWith를 신규로그에 대해 사용하지 않기로 했으나, objectWith 참조하는 곳 파악이 필요하여 objectWith와 신규서버로그에 동일한 정보 전달
     *https://docs.google.com/document/d/1n0zLiXqYVAr3aQNwJHVq1FxYAPQXi0-Cdr2xc7-aWWk/edit#heading=h.48viz2kqokmm
     *영향을 주는 레거시가 많기 때문에 해당 부분은 실제 데이터는 들어가지만 정보는 주석으로 정리함. - 하지만, "실제로는 남기는 값"
     *objects_with : [{ $placeNo, $position, $adSlot?, $adSlotId?, $adSeq?, $adTags?, $positionInSlot?, $b2bCouponAd?,
     *$b2bCouponPlus?, $hotDeal?, $badgeInfo,
     *$hasRentInventory, $hasStayInventory, $rentPriceMemberCode?,$stayPriceMemberCode?,$badgeMemberCode?,
     *rent_coupons, $stay_coupons }]
     **** SRP 버티컬 탭 통합 전까지는 objectsWith에 아래의 message가 들어가야 합니다.
     *# 노출 로그가 하나였을 때는 ['{상품}', '{상품}', '{상품}'] 형식이었으나, 상품별로 로그를 발생시키면서
     *# ['{상품}']의 형태로 들어갑니다. # 이미지: https://screen.yanolja.in/tk2HqoGV2u68aRqF.png
     *https://screen.yanolja.in/Quty64RuqijVNRps.png
     *event_label : "imprPlace"  # 해당 이벤트도 구버전이므로 주석으로 정리 - 실제로는 남기는 값
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNamePlaceNo {
    /**
     * https://screen.yanolja.in/Quty64RuqijVNRps.png
     *event_label : "clickPlace"  # 해당 이벤트는 구버전이므로 주석으로 정리 - 실제로는 남기는 값
     *########  < 국내숙소 recommendSection 위젯 >  정의 시작 #########
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      placeNo: string;
      listName: string;
    }
  }
  export namespace RecommendSectionCardWidgetItem {
    /**
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     */
    export interface Impression {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     * https://screen.yanolja.in/E18YjmTw8HI3rXrT.png
     */
    export interface Click {
      /**
       * * 위젯 정보 ****  #https://screen.yanolja.in/1voQZsLupI0zBp1L.png
       *위젯 내 상품 순서 (광고의 positionInSlot과 유사한 개념)
       */
      position: number;
      /* 전체 상품 리스트 내 상품 순서 (광고, 일반 상품까지 모두 포함한 상품 리스트 내 상품 순서로 상품 로그의 position과 유사한 개념)*/
      listPosition: number;
      /* 검색결과 - NoResult 노출*/
      noAvailablePlaceMsg?: boolean;
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace ListNameLabelNoAvailablePlaceMsg {
    /**
     * 실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameLabelSpellCorrectionMsg {
    /**
     * https://screen.yanolja.in/gn7ng86cx3VNOF8t
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/gn7ng86cx3VNOF8t
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameButtonBackwardBtn {
    /**
     * https://screen.yanolja.in/9CBq2ar1c7oBaCpS.png
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonHomeBtn {
    /**
     * https://screen.yanolja.in/TuQAu1HUSlhlacPS.png
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonCartBtn {
    /**
     * https://screen.yanolja.in/iZdwEbPaKpsd2ruP.png
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonSearchBtn {
    /**
     * https://screen.yanolja.in/aBNE3bA0sOBf76gL
     */
    export interface Click {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNameTabBtn {
    /**
     * https://screen.yanolja.in/rQmX5bjr5Kr87Jbs.png
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/rQmX5bjr5Kr87Jbs.png
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace RelatedKeywordsLabelKeyword {
    /**
     * https://screen.yanolja.in/A0uxbUXfpQIlrA1d.png
     *실제 로그상에는 값이 없음(추가하지 않아도됨). proto 정의시 필수라 추가
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace RelatedKeywordsLabel {
    /**
     * https://screen.yanolja.in/A0uxbUXfpQIlrA1d.png
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      relatedKeywords: string;
    }
  }
  export namespace ListName {
    /**
     * https://screen.yanolja.in/WhsqGVJCEeJpJctm.png
     */
    export interface View {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/WhsqGVJCEeJpJctm.png
     *########  < 국내숙소 지역별 리스트 >  정의 시작 ######
     */
    export interface Resume {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNameButtonSetMapview {
    /**
     * https://screen.yanolja.in/usveO76fAla16W4l.png
     *########  < 국내숙소 지도뷰 리스트 >  정의 시작 #########
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
  export namespace ListNameBannerOm {
    /**
     * https://screen.yanolja.in/PNjIf2au562k798M
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }

    /**
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
}

/**
 * PageName: AREA_LIST
 */
export const AreaListPageLog = {
  ListName: {
    /**
     * 국내숙소 지역별 리스트 진입
     * https://screen.yanolja.in/U5KxjL5vuPV5gVlU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L501}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    view({ sourcePage, locationInfo, listName }: AreaListPageLog.ListName.View) {
      return KinesisTracker.view('AREA_LIST', {
        clientEventId: 509,
        pageName: 'PAGE_NAME_AREA_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_VIEW',
        sourcePage,
        locationInfo,
      });
    },

    /**
     * 국내숙소 지역별 리스트 진입
     * https://screen.yanolja.in/U5KxjL5vuPV5gVlU.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L510}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    resume({ sourcePage, locationInfo, listName }: AreaListPageLog.ListName.Resume) {
      return KinesisTracker.resume('AREA_LIST', {
        clientEventId: 510,
        pageName: 'PAGE_NAME_AREA_LIST',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_RESUME',
        sourcePage,
        locationInfo,
      });
    },
  },

  ListNameRegion: {
    /**
     * 국내숙소 지역별 리스트 - depth 1/2 지역 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L519}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    impression({ sourcePage, locationInfo, logMeta, regionName, listName }: AreaListPageLog.ListNameRegion.Impression) {
      return KinesisTracker.impression('AREA_LIST', {
        clientEventId: 511,
        pageName: 'PAGE_NAME_AREA_LIST',
        object: regionName,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_REGION_NAME',
        eventType: 'EVENT_TYPE_IMPR',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },

    /**
     * 국내숙소 지역별 리스트 - depth 1/2 지역 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L532}
     * ProductListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L51}
     */
    click({ sourcePage, locationInfo, logMeta, regionName, listName }: AreaListPageLog.ListNameRegion.Click) {
      return KinesisTracker.click('AREA_LIST', {
        clientEventId: 512,
        pageName: 'PAGE_NAME_AREA_LIST',
        object: regionName,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_REGION_NAME',
        eventType: 'EVENT_TYPE_CLICK',
        sourcePage,
        locationInfo,
        ...logMeta,
      });
    },
  },

  ListNameButtonCloseBtn: {
    /**
     * 닫기 버튼
     * https://screen.yanolja.in/MPqybWlyBWbUV4IZ.png
     *########  < 국내숙소 지역별 리스트 >  정의 끝 ######
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L545}
     */
    click({ listName }: AreaListPageLog.ListNameButtonCloseBtn.Click) {
      return KinesisTracker.click('AREA_LIST', {
        clientEventId: 513,
        pageName: 'PAGE_NAME_AREA_LIST',
        object: 'closeBtn',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace AreaListPageLog {
  export namespace ListName {
    /**
     * https://screen.yanolja.in/U5KxjL5vuPV5gVlU.png
     */
    export interface View {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/U5KxjL5vuPV5gVlU.png
     */
    export interface Resume {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      listName: string;
    }
  }
  export namespace ListNameRegion {
    /**
     */
    export interface Impression {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      regionName: string;
      listName: string;
    }

    /**
     */
    export interface Click {
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      regionName: string;
      listName: string;
    }
  }
  export namespace ListNameButtonCloseBtn {
    /**
     * https://screen.yanolja.in/MPqybWlyBWbUV4IZ.png
     *########  < 국내숙소 지역별 리스트 >  정의 끝 ######
     */
    export interface Click {
      listName: string;
    }
  }
}

/**
 * PageName: PLACE_MAP
 */
export const PlaceMapPageLog = {
  ListName: {
    /**
     * 국내숙소 지도뷰 리스트 진입
     * https://screen.yanolja.in/1N6xo1lU7XbrJ4gk.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L572}
     * AccommodationKoreaListCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L406}
     */
    view({
      keyword,
      tabName,
      sortType,
      filter,
      regionCode,
      checkInDate,
      checkOutDate,
      sourcePage,
      locationInfo,
      roomPeople,
      correctedKeyword,
      listName,
    }: PlaceMapPageLog.ListName.View) {
      return KinesisTracker.view('PLACE_MAP', {
        clientEventId: 517,
        pageName: 'PAGE_NAME_PLACE_MAP',
        objectContainer: listName,
        eventType: 'EVENT_TYPE_VIEW',
        keyword,
        tabName,
        sortType,
        filter,
        regionCode,
        checkInDate,
        checkOutDate,
        sourcePage,
        locationInfo,
        roomPeople,
        correctedKeyword,
      });
    },
  },

  ListNamePlaceNo: {
    /**
     * PlaceMap - (pin 클릭 후) 숙소 노출
     * https://screen.yanolja.in/cNZhnbHILgnCajYf.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L581}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/product_item.proto#L0}
     */
    impression({ logMeta, placeNo, listName }: PlaceMapPageLog.ListNamePlaceNo.Impression) {
      return KinesisTracker.impression('PLACE_MAP', {
        clientEventId: 518,
        pageName: 'PAGE_NAME_PLACE_MAP',
        object: placeNo,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_PLACE_NO',
        eventType: 'EVENT_TYPE_IMPR',
        ...logMeta,
      });
    },

    /**
     * PlaceMap - 숙소 클릭
     * https://screen.yanolja.in/2ueQn0CZjOeDASlg.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L593}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/product_item.proto#L0}
     */
    click({ logMeta, placeNo, listName }: PlaceMapPageLog.ListNamePlaceNo.Click) {
      return KinesisTracker.click('PLACE_MAP', {
        clientEventId: 519,
        pageName: 'PAGE_NAME_PLACE_MAP',
        object: placeNo,
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_PLACE_NO',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },

  ListNameButtonSeeMore: {
    /**
     * PlaceMap - 숙소 더보기 클릭
     * https://screen.yanolja.in/ZQg03IioGGcIt0RO.png
     *# OM Banner
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/product_list/accommodations_korea/web.txtpb#L605}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/accommodations_korea.proto#L0}
     */
    click({ logMeta, listName }: PlaceMapPageLog.ListNameButtonSeeMore.Click) {
      return KinesisTracker.click('PLACE_MAP', {
        clientEventId: 520,
        pageName: 'PAGE_NAME_PLACE_MAP',
        object: 'seeMore',
        objectContainer: listName,
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace PlaceMapPageLog {
  export namespace ListName {
    /**
     * https://screen.yanolja.in/1N6xo1lU7XbrJ4gk.png
     */
    export interface View {
      /* $listName=search 인 경우 검색어*/
      keyword?: string;
      /* $listName=지역 or general 인 경우, tab 이름 ex) 모텔, 놀이동산*/
      tabName?: string;
      /* 리스트 정렬 타입 (PRICE_ASC, RECOMMEND, ...)*/
      sortType?: string;
      /* filter 정보*/
      filter?: FilterRequest;
      /* 상권유형별 지역 코드값 , PlaceList 중 반영대상: $listName in (Motel | Myroom | Hotel | Pension | GuestHouse). ex)900199 (=남이섬/자라섬/가평북부)*/
      regionCode?: string;
      /* 설정된 체크인 날짜*/
      checkInDate?: string;
      /* 설정된 체크아웃 날짜*/
      checkOutDate?: string;
      /* if($listName=OldStation) 경우 진입 경로를 의미함.*/
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 객실 정보. 없으면 빈값*/
      roomPeople?: RoomPeople[];
      /* 오타 입력 시 정타로 치환된 검색 결과의 경우*/
      correctedKeyword?: string;
      listName: string;
    }
  }
  export namespace ListNamePlaceNo {
    /**
     * https://screen.yanolja.in/cNZhnbHILgnCajYf.png
     */
    export interface Impression {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      placeNo: string;
      listName: string;
    }

    /**
     * https://screen.yanolja.in/2ueQn0CZjOeDASlg.png
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      placeNo: string;
      listName: string;
    }
  }
  export namespace ListNameButtonSeeMore {
    /**
     * https://screen.yanolja.in/ZQg03IioGGcIt0RO.png
     *# OM Banner
     */
    export interface Click {
      /* 서버 로그 바이패스*/
      logMeta?: any;
      listName: string;
    }
  }
}
